import React, { Component } from "react";

import { Link } from "react-router-dom";
import MetisMenu from "metismenujs";
import PropTypes from "prop-types";
import SimpleBar from "simplebar-react";
import { getPermission } from "../../helpers/auth_helper";
import { withRouter } from "react-router-dom";
import { withTranslation } from "react-i18next";

// MetisMenu

//Simple bar

//i18n



class SidebarContent extends Component {
  constructor(props) {
    const permission = getPermission();
    // console.log(permission);
    super(props);
    this.refDiv = React.createRef();
  }

  componentDidMount() {
    this.initMenu();
  }

  // eslint-disable-next-line no-unused-vars
  componentDidUpdate(prevProps, prevState, ss) {
    if (this.props.type !== prevProps.type) {
      this.initMenu();
    }
  }

  initMenu() {
    new MetisMenu("#side-menu");

    let matchingMenuItem = null;
    const ul = document.getElementById("side-menu");
    const items = ul.getElementsByTagName("a");
    // for (let i = 0; i < items.length; ++i) {
    //   if (this.props.location.pathname === items[i].pathname) {
    //     matchingMenuItem = items[i];
    //     break;
    //   }
    // }

    const parentPath = [
      "/shipper",
      "/booking-data",
      "/nomination-week",
      "/nomination-day",
      "/allocation-data",
      "/metering-data-daily",
      "/metering-data-monthly",
      "/role-management",
      "/quality-point-daily",
      "/tpa-daily-report",
      "/gas-composition-report",
      "/viewer-booking",
      "/viewer-allocation",
      "/viewer-nomination-day",
      "/viewer-metering-month",
      "/shift-report",
      "/delivery-gas-fuel-gas-report",
      "/average-gas-delivery-report",
      "/gas-delivery-performance-report",
      "/actual-supply-demand-actual-gsm",
      // "/flow-selection",
    ];
    const indexOfParent = parentPath.find(
      path => this.props.location.pathname.indexOf(path) >= 0
    );
    if (
      indexOfParent &&
      this.props.location.pathname.indexOf(indexOfParent) >= 0
    ) {
      let index = parentPath.indexOf(indexOfParent);

      for (let i = 0; i < items.length; ++i) {
        if (parentPath[index] === items[i].href.split('#')[1]) {
          matchingMenuItem = items[i];
          break;
        }
      }
    } else {

      for (let i = 0; i < items.length; ++i) {
        if (this.props.location.pathname === items[i].href.split('#')[1]) {
          matchingMenuItem = items[i];
          break;
        }
      }
    }

    if (matchingMenuItem) {
      this.activateParentDropdown(matchingMenuItem);
    }
  }

  // componentDidUpdate() {}

  scrollElement = item => {
    setTimeout(() => {
      if (this.refDiv.current !== null) {
        if (item) {
          const currentPosition = item.offsetTop;
          if (currentPosition > window.innerHeight) {
            if (this.refDiv.current)
              this.refDiv.current.getScrollElement().scrollTop =
                currentPosition - 300;
          }
        }
      }
    }, 300);
  };

  activateParentDropdown = item => {
    item.classList.add("active");
    const parent = item.parentElement;

    const parent2El = parent.childNodes[1];
    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show");
    }

    if (parent) {
      parent.classList.add("mm-active");
      const parent2 = parent.parentElement;

      if (parent2) {
        parent2.classList.add("mm-show"); // ul tag

        const parent3 = parent2.parentElement; // li tag

        if (parent3) {
          parent3.classList.add("mm-active"); // li
          parent3.childNodes[0].classList.add("mm-active"); //a
          const parent4 = parent3.parentElement; // ul
          if (parent4) {
            parent4.classList.add("mm-show"); // ul
            const parent5 = parent4.parentElement;
            if (parent5) {
              parent5.classList.add("mm-show"); // li
              parent5.childNodes[0].classList.add("mm-active"); // a tag
            }
          }
        }
      }
      this.scrollElement(item);
      return false;
    }
    this.scrollElement(item);
    return false;
  };

  render() {

    const permission = getPermission();
    // console.log(permission);
    return (
      <React.Fragment>
        <SimpleBar className="h-100" ref={this.refDiv}>
          <div id="sidebar-menu">
            <ul className="metismenu list-unstyled" id="side-menu">
              <li className="menu-title">{this.props.t("Menu")}</li>

              {(permission?.DHME || permission?.DBUI) && (
                <li>
                  <Link className="has-arrow" to="/#">
                    <i className="bx bx-home-circle" />
                    <span>{this.props.t("Dashboards")}</span>
                  </Link>
                  <ul className="sub-menu" aria-expanded="false">

                    {permission?.DHME && (
                      <li>
                        <Link to="/dashboard">
                          <span>{this.props.t("Daily Dashboard")}</span>
                        </Link>
                      </li>
                    )}

                    {permission?.DBUI && (
                      <li>
                        <Link to="/bi-dashboard">
                          <span>{this.props.t("BI Dashboard")}</span>
                        </Link>
                      </li>
                    )}

                  </ul>
                </li>
              )}

              {(permission?.vBKD || permission?.vNMW || permission?.vNMD || permission?.vMTD || permission?.vALD || permission?.vMTM || permission?.vQPD) && (
                <li>
                  <Link to="/#" className="has-arrow">
                    <i className="bx bx-log-in" />
                    <span>{this.props.t("Input Management (Upload)")}</span>
                  </Link>
                  <ul className="sub-menu" aria-expanded="false">
                    {/* <li>
                    <Link to="/booking-data-old">
                      <span>{this.props.t("Booking Data")}1</span>
                    </Link>
                  </li> */}

                    {permission?.vBKD && (
                      <li>
                        <Link to="/booking-data">
                          <span>{this.props.t("Booking Data")}</span>
                        </Link>
                      </li>
                    )}

                    {permission?.vNMW && (
                      <li>
                        <Link to="/nomination-week">
                          <span>{this.props.t("Nomination Week")}</span>
                        </Link>
                      </li>
                    )}

                    {permission?.vNMD && (
                      <li>
                        <Link to="/nomination-day">
                          <span>{this.props.t("Nomination Day")}</span>
                        </Link>
                      </li>
                    )}

                    {permission?.vMTD && (
                      <li>
                        <Link to="/metering-data-daily">
                          <span>{this.props.t("Metering Data ( Daily )")}</span>
                        </Link>
                      </li>
                    )}

                    {permission?.vALD && (
                      <li>
                        <Link to="/allocation-data">
                          <span>{this.props.t("Allocation Data")}</span>
                        </Link>
                      </li>
                    )}

                    {permission?.vMTM && (
                      <li>
                        <Link to="/metering-data-monthly">
                          <span>{this.props.t("Metering Data ( Monthly )")}</span>
                        </Link>
                      </li>
                    )}

                    {permission?.vQPD && (
                      <li>
                        <Link to="/quality-point-daily">
                          <span>{this.props.t("Quality Point Daily ( GC Name )")}</span>
                        </Link>
                      </li>
                    )}

                  </ul>
                </li>

              )}

              {permission?.vFSN && (
                <li>
                  <Link to="/flow-selection">
                    <i className="bx bx-spray-can" />
                    <span>{this.props.t("Flow / HV / Energy Selection")}</span>
                  </Link>
                  {/* <ul className="sub-menu" aria-expanded="false">

                    {permission?.vFSN && (
                      <li>
                        <Link to="/flow-selection">
                          <span>{this.props.t("Flow Selection")}</span>
                        </Link>
                      </li>
                    )}

                    {permission?.vFLC && (
                      <li>
                        <Link to="/flow-logic">
                          <span>
                            {this.props.t("Flow Logic")}
                          </span>
                        </Link>
                      </li>
                    )}

                  </ul> */}
                </li>
              )}

              {(permission?.vGLP || permission?.vFFO || permission?.vBSG || permission?.vDFO || permission?.vOTH || permission?.vGAC) && (
                <li>
                  <Link className="has-arrow" to="/#">
                    <i className="bx bx-calendar-heart" />
                    <span>{this.props.t("Manual Data Entry")}</span>
                  </Link>
                  <ul className="sub-menu" aria-expanded="false">
                    {permission?.vGLP && (
                      <li>
                        <Link to="/gas-volumn-line-pack">
                          <span>{this.props.t("Gas Volume & Line Pack")}</span>
                        </Link>
                      </li>
                    )}
                    {permission?.vFFO && (
                      <li>
                        <Link to="/flow-fuel-monthly-daily">
                          <span>
                            {this.props.t("Flow/Fuel ( Monthly & Daily )")}
                          </span>
                        </Link>
                      </li>
                    )}
                    {permission?.vBSG && (
                      <li>
                        <Link to="/balancing-shinkgate-gas-data">
                          <span>
                            {this.props.t("Balancing & Shrinkage Gas Data")}
                          </span>
                        </Link>
                      </li>
                    )}
                    {permission?.vDFO && (
                      <li>
                        <Link to="/diesel-fuel-oil-data">
                          <span>{this.props.t("Diesel & Fuel Oil Data")}</span>
                        </Link>
                      </li>
                    )}
                    {permission?.vOTH && (
                      <li>
                        <Link to="/other-key-in-data">
                          <span>{this.props.t("Other Key-in Data")}</span>
                        </Link>
                      </li>
                    )}
                    {permission?.vGAC && (
                      <li>
                        <Link to="/gas-composition">
                          <span>{this.props.t("Gas Composition")}</span>
                        </Link>
                      </li>
                    )}
                  </ul>
                </li>
              )}

              {permission?.vALM && (
                <li>
                  <Link to="/alarm-management">
                    <i className="bx bx-caret-right-square" />
                    <span>{this.props.t("Alarm Management")}</span>
                  </Link>
                </li>
              )}

              {permission?.vSRT && (
                <li>
                  <Link to="/summary-report">
                    <i className="bx bx-show-alt" />
                    <span>{this.props.t("Summary Report")}</span>
                  </Link>
                </li>
              )}

              {(permission?.vTPA || permission?.vTBR || permission?.vPUR || permission?.vAGD || permission?.vGDP || permission?.vDGF || permission?.vSTR ||
                permission?.vASD || permission?.vGCN) && (
                  <li>
                    <Link className="has-arrow" to="/#">
                      <i className="bx bxs-report" />
                      <span>{this.props.t("Report")}</span>
                    </Link>
                    <ul className="sub-menu" aria-expanded="false">

                      {permission?.vTPA && (
                        <li>
                          <Link to="/tpa-daily-report">
                            <span>{this.props.t("TPA Daily")}</span>
                          </Link>
                        </li>
                      )}

                      {/* <li>
                    <Link to="/offshore-balacing-report">
                      <span>{this.props.t("Offshore Balacing Report")}</span>
                    </Link>
                  </li> */}
                      {permission?.vTBR && (
                        <li>
                          <Link to="/tpa-balancing-and-overuse-report">
                            <span>{this.props.t("TPA Balancing & Overuse")}</span>
                          </Link>
                        </li>
                      )}
                      {/* <li>
                    <Link to="/tpa-balancing-report">
                      <span>{this.props.t("TPA Balancing Report")}</span>
                    </Link>
                  </li>
                  <li>
                    <Link to="/tpa-capacity-overuse-report">
                      <span>{this.props.t("TPA Capacity Overuse Report")}</span>
                    </Link>
                  </li> */}
                      {permission?.vPUR && (
                        <li>
                          <Link to="/pipeline-utilization-report">
                            <span>{this.props.t("Pipeline Utilization")}</span>
                          </Link>
                        </li>
                      )}
                      {permission?.vAGD && (
                        <li>
                          <Link to="/average-gas-delivery-report">
                            <span>{this.props.t("Average Gas Delivery")}</span>
                          </Link>
                        </li>
                      )}
                      {permission?.vGDP && (
                        <li>
                          <Link to="/gas-delivery-performance-report">
                            <span>
                              {this.props.t("Gas Delivery Performance")}
                            </span>
                          </Link>
                        </li>
                      )}
                      {permission?.vDGF && (
                        <li>
                          <Link to="/delivery-gas-fuel-gas-report">
                            <span>
                              {this.props.t("Delivery Gas / Fuel Gas")}
                            </span>
                          </Link>
                        </li>
                      )}
                      {permission?.vSTR && (
                        <li>
                          <Link to="/shift-report">
                            <span>{this.props.t("Shift")}</span>
                          </Link>
                        </li>
                      )}
                      {permission?.vASD && (
                        <li>
                          <Link to="/actual-supply-demand-actual-gsm">
                            <span>
                              {this.props.t("Actual Supply Demand ( Actual-GSM )")}
                            </span>
                          </Link>
                        </li>
                      )}
                      {permission?.vGCN && (
                        <li>
                          <Link to="/gas-composition-report">
                            <span>{this.props.t("Gas Composition")}</span>
                          </Link>
                        </li>
                      )}
                      {/* <li>
                    <Link to="/export-raw-data">
                      <span>{this.props.t("Export Raw Data")}</span>
                    </Link>
                  </li> */}
                    </ul>
                  </li>

                )}


              {(permission?.vRVB || permission?.vRVN || permission?.vRVA || permission?.vRVM || permission?.vEOD) && (

                <li>
                  <Link to="/#" className="has-arrow">
                    <i className="mdi mdi-file-import-outline" />
                    <span>{this.props.t("Report Viewer")}</span>
                  </Link>
                  <ul className="sub-menu" aria-expanded="false">

                    {permission?.vRVB && (
                      <li>
                        <Link to="/viewer-booking">
                          <span>{this.props.t("Booking Data")}</span>
                        </Link>
                      </li>
                    )}

                    {permission?.vRVN && (
                      <li>
                        <Link to="/viewer-nomination-day">
                          <span>{this.props.t("Nomination Day")}</span>
                        </Link>
                      </li>
                    )}

                    {permission?.vRVM && (
                      <li>
                        <Link to="/viewer-metering-month">
                          <span>{this.props.t("Metering Data ( Monthly )")}</span>
                        </Link>
                      </li>
                    )}

                    {permission?.vRVA && (
                      <li>
                        <Link to="/viewer-allocation">
                          <span>{this.props.t("Allocation Data")}</span>
                        </Link>
                      </li>
                    )}

                    {permission?.vEOD && (
                      <li>
                        <Link to="/eod-summary-report">
                          <span>{this.props.t("EOD Summary")}</span>
                        </Link>
                      </li>
                    )}

                  </ul>
                </li>

              )}

              {/* <li>
                <Link to="/report-formation">
                  <i className="bx bx-file-blank" />
                  <span>{this.props.t("Report Formation")}</span>
                </Link>
              </li> */}

              {/* <li>
                <Link to="/criteria-formular-editing">
                  <i className="bx bx-edit-alt" />
                  <span>{this.props.t("Criteria & Formular Editing")}</span>
                </Link>
              </li> */}

              {(permission?.vUSM || permission?.vRMN) && (
                <li>
                  <Link className="has-arrow" to="/#">
                    <i className="bx bx-user" />
                    <span>{this.props.t("User Management")}</span>
                  </Link>
                  <ul className="sub-menu" aria-expanded="false">
                    {permission?.vUSM && (
                      <li>
                        <Link to="/user-management">
                          <span>{this.props.t("User Management")}</span>
                        </Link>
                      </li>
                    )}
                    {permission?.vRMN && (
                      <li>
                        <Link to="/role-management">
                          <span>{this.props.t("Role Management")}</span>
                        </Link>
                      </li>
                    )}
                    {permission?.vEMP && (
                      <li>
                        <Link to="/e-mail-management">
                          <span>{this.props.t("E-mail Management")}</span>
                        </Link>
                      </li>
                    )}

                    {/* <li>
                    <Link to="/refresh-data-from-pis">
                      <span>{this.props.t("Refresh data from PIS")}</span>
                    </Link>
                  </li> */}
                    {/* <li>
                    <Link to="/manage-email-by-report">
                      <span>{this.props.t("Manage Email by Report")}</span>
                    </Link>
                  </li> */}
                  </ul>
                </li>
              )}

              {(permission?.vSHP || permission?.vMET || permission?.vVMT || permission?.vOTR || permission?.vFLC) && (
                <li>
                  <Link className="has-arrow" to="/#">
                    <i className="bx bx-cog" />
                    <span>{this.props.t("Master Data Setting")}</span>
                  </Link>
                  <ul className="sub-menu" aria-expanded="false">
                    {permission?.vSHP && (
                      <li>
                        <Link to="/shipper">
                          <span>{this.props.t("Shipper")}</span>
                        </Link>
                      </li>
                    )}
                    {permission?.vMET && (
                      <li>
                        <Link to="/meter">
                          <span>{this.props.t("Meter")}</span>
                        </Link>
                      </li>
                    )}
                    {permission?.vVMT && (
                      <li>
                        <Link to="/virtual-meter">
                          <span>{this.props.t("Virtual Meter")}</span>
                        </Link>
                      </li>
                    )}
                    {permission?.vFLC && (
                      <li>
                        <Link to="/flow-logic">
                          <span>
                            {this.props.t("Flow Logic")}
                          </span>
                        </Link>
                      </li>
                    )}
                    {permission?.vOTR && (
                      <li>
                        <Link className="has-arrow" to="">
                          <span>{this.props.t("Other")}</span>
                        </Link>
                        <ul className="sub-menu" aria-expanded="false">
                          {/* <li>
                        <Link to="/customer">
                          <span>{this.props.t("Customer")}</span>
                        </Link>
                      </li> */}
                          <li>
                            <Link to="/customer-type">
                              <span>{this.props.t("Customer Type")}</span>
                            </Link>
                          </li>
                          <li>
                            <Link to="/zone">
                              <span>{this.props.t("Zone")}</span>
                            </Link>
                          </li>
                          <li>
                            <Link to="/point">
                              <span>{this.props.t("Point")}</span>
                            </Link>
                          </li>
                          <li>
                            <Link to="/region">
                              <span>{this.props.t("Region")}</span>
                            </Link>
                          </li>
                          <li>
                            <Link to="/nomination">
                              <span>{this.props.t("Nomination")}</span>
                            </Link>
                          </li>
                          <li>
                            <Link to="/area">
                              <span>{this.props.t("Area")}</span>
                            </Link>
                          </li>
                          <li>
                            <Link to="/sub-area">
                              <span>{this.props.t("Sub Area")}</span>
                            </Link>
                          </li>
                          <li>
                            <Link to="/bv-zone">
                              <span>{this.props.t("BV Zone")}</span>
                            </Link>
                          </li>
                          <li>
                            <Link to="/block-valve">
                              <span>{this.props.t("Block Valve")}</span>
                            </Link>
                          </li>
                          <li>
                            <Link to="/industrial-estate">
                              <span>{this.props.t("Industrial Estate")}</span>
                            </Link>
                          </li>
                          <li>
                            <Link to="/quality-point">
                              <span>{this.props.t("Quality Point")}</span>
                            </Link>
                          </li>
                          {/* <li>
                            <Link to="/remark1">
                              <span>{this.props.t("Quality Point ( Backup 1 )")}</span>
                            </Link>
                          </li>
                          <li>
                            <Link to="/remark2">
                              <span>{this.props.t("Quality Point ( Backup 2 )")}</span>
                            </Link>
                          </li> */}
                          <li>
                            <Link to="/remark3">
                              <span>{this.props.t("Remark 3")}</span>
                            </Link>
                          </li>
                          <li>
                            <Link to="/remark4">
                              <span>{this.props.t("Remark 4")}</span>
                            </Link>
                          </li>
                          <li>
                            <Link to="/remark5">
                              <span>{this.props.t("Remark 5")}</span>
                            </Link>
                          </li>
                        </ul>
                      </li>
                    )}
                  </ul>
                </li>
              )}

              {/* <li>
                <Link className="has-arrow" to="/#">
                  <i className="bx bx-window" />
                  <span>{this.props.t("Tag Mapping")}</span>
                </Link>
                <ul className="sub-menu" aria-expanded="false">
                  <li>
                    <Link to="/gas-compostion-tag">
                      <span>{this.props.t("Gas Compostion Tag")}</span>
                    </Link>
                  </li>
                  <li>
                    <Link to="/flow-fuel-tag">
                      <span>{this.props.t("Flow / Fuel Tag")}</span>
                    </Link>
                  </li>
                </ul>
              </li> */}

              {permission?.vDUL && (
                <li>
                  <Link to="/dashboard-url">
                    <i className="bx bx-desktop" />
                    <span>{this.props.t("Dashboard URL")}</span>
                  </Link>
                </li>
              )}

              {(permission?.vAPI || permission.vAPP) && (
                <li>
                  <Link className="has-arrow" to="/#">
                    <i className="bx bx-layer-plus" />
                    <span>{this.props.t("System Config")}</span>
                  </Link>
                  <ul className="sub-menu" aria-expanded="false">
                    {permission?.vAPI && (
                      <li>
                        <Link to="/api-schedule-run">
                          <span>{this.props.t("API Schedule Run")}</span>
                        </Link>
                      </li>
                    )}
                    {permission?.vAPP && (
                      <li>
                        <Link to="/api-parameter">
                          <span>{this.props.t("API PMIS Parameter")}</span>
                        </Link>
                      </li>
                    )}

                    {/* <li>
                    <Link to="/datasource-connection">
                      <span>{this.props.t("Data Source Connection")}</span>
                    </Link>
                  </li> */}

                  </ul>
                </li>
              )}
            </ul>
          </div>
        </SimpleBar>
      </React.Fragment>
    );
  }
}

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
  type: PropTypes.string,
};

export default withRouter(withTranslation()(SidebarContent));
